import { useTranslation } from 'react-i18next';

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gray-50 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#FF6B6B]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#4ECDC4]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/f50f7f01d590d113e2ab632ba4ced43c.jpg"
                alt="Client satisfait du service de réparation"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-6 shadow-xl">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-shield-star-fill text-[#4ECDC4] text-2xl"></i>
                <span className="font-bold text-gray-900">{t('testimonial.badge')}</span>
              </div>
              <p className="text-gray-600 text-sm font-medium">{t('testimonial.badgeDesc')}</p>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl -z-10"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-full -z-10 opacity-50"></div>
          </div>

          {/* Content */}
          <div>
            <div className="relative">
              <i className="ri-double-quotes-l text-8xl text-[#FF6B6B]/20 absolute -top-8 -left-4"></i>
              
              <blockquote className="relative z-10 text-2xl md:text-3xl text-gray-900 leading-relaxed mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                {t('testimonial.quote')}
                <span className="bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] bg-clip-text text-transparent font-bold"> {t('testimonial.quoteHighlight')}</span>
                {t('testimonial.quoteEnd')}
              </blockquote>
            </div>
            
            <div className="flex items-center gap-4 mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center">
                <i className="ri-plane-fill text-white text-2xl"></i>
              </div>
              <div>
                <p className="text-gray-900 font-bold text-lg" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {t('testimonial.optimizedFor')}
                </p>
                <p className="text-gray-500">{t('testimonial.companies')}</p>
                <p className="text-[#4ECDC4] font-medium">{t('testimonial.readyFor')}</p>
              </div>
            </div>

            {/* Value Points */}
            <div className="mt-10 grid grid-cols-1 gap-4">
              <div className="flex items-start gap-4 p-4 bg-white rounded-2xl shadow-sm">
                <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-euro-circle-fill text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>{t('testimonial.value1Title')}</div>
                  <div className="text-gray-500 text-sm">{t('testimonial.value1Desc')}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 bg-white rounded-2xl shadow-sm">
                <div className="w-10 h-10 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-file-shield-2-fill text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>{t('testimonial.value2Title')}</div>
                  <div className="text-gray-500 text-sm">{t('testimonial.value2Desc')}</div>
                </div>
              </div>
              <div className="flex items-start gap-4 p-4 bg-white rounded-2xl shadow-sm">
                <div className="w-10 h-10 bg-gradient-to-br from-[#A855F7] to-[#9333EA] rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-recycle-fill text-white"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900" style={{ fontFamily: 'Poppins, sans-serif' }}>{t('testimonial.value3Title')}</div>
                  <div className="text-gray-500 text-sm">{t('testimonial.value3Desc')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
